<template>
  <div class="c-header">
    <div class="main">
      <div class="logo">
        <a
          :href="tempSett.logoLinkUrl || 'javascript:;'"
          :target="tempSett.logoLinkUrl ? '_blank' : ''"
        >
          <img :src="tempSett.logoUrl || './images/logo.png'" alt="" />
        </a>
      </div>
      <Navs></Navs>
      <div class="c-search">
        <label>
          <input
            type="text"
            :placeholder="$t('PLEASE_ENTER_KEY_WORDS')"
            v-model="keyword"
            @keyup="keySearch($event)"
          />
        </label>
        <div class="img" @click="search()">
          <img src="../assets/images/search-icon.png" alt="" />
        </div>
      </div>
      <div class="contact">
        <a class="u-mr5" @click="login()" v-if="!isLogin && tempSett.isLogin">
          {{ $t("LOG_IN") }}
        </a>
        <a @click="reg()" v-if="!isLogin && tempSett.isLogin">
          {{ $t("REGISTERED") }}
        </a>
        <span class="u-mr10" v-if="isLogin && tempSett.isLogin">
          {{ $t("HELLO") }} {{ contactInfo.name }}
        </span>
        <a v-if="isLogin && tempSett.isLogin" @click="logout()">{{
          $t("DROP_OUT")
        }}</a>
      </div>
    </div>
    <div class="iphone">
      <div class="logo">
        <a :href="tempSett.logoLinkUrl || 'javascript:;'">
          <img :src="tempSett.logoUrl || './images/logo.png'" alt="" />
        </a>
      </div>
      <div class="c-search">
        <label>
          <input
            type="text"
            :placeholder="$t('PLEASE_ENTER_KEY_WORDS')"
            v-model="keyword"
            @keyup="keySearch($event)"
          />
        </label>
        <div class="img" @click="search()">
          <img src="../assets/images/search-icon.png" alt="" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ck } from "fire-wind-water/cookie";
import { $subscriber } from "fire-wind-water/tools/subscriber";
import Navs from "./Navs";
import account from "../services/account";
import { URLS } from "fire-wind-water/url";

const tenantId = URLS.getURL("tenantId");

export default {
  name: "Header",
  components: { Navs },
  data() {
    return {
      keyword: "",
      tempSett: {},
      isLogin: false,
      contactInfo: {},
      backUrl: "&backUrl=" + encodeURIComponent(window.location.href)
    };
  },
  methods: {
    search() {
      const path = this.keyword ? `/search/${this.keyword}` : `/search`;
      if (this.$router.history.current.path != path) {
        this.$router.push({ path: path });
      }
    },
    keySearch(ev) {
      if (ev.keyCode == 13) {
        this.search();
      }
    },
    initLogin() {
      this.isLogin = false;
      if (this.tempSett.registrationFormId) {
        const user = ck.cookie(`smarketMember_${this.tempSett.schemaId}`);
        if (user) {
          this.isLogin = true;
          account
            .getContact({
              tenantId,
              schemaId: this.tempSett.schemaId,
              sess: user.session,
              globalUserId: ck.cookie("globalUserId"),
              isTemplate: 1
            })
            .then(data => {
              if (data.result == 0) {
                this.contactInfo = data.content;
                $subscriber.emit("contact-info", this.contactInfo);
              } else {
                this.$message.error(data.desc);
              }
            });
        }
      }
    },
    logout() {
      this.isLogin = false;
      const user = ck.cookie(`smarketMember_${this.tempSett.schemaId}`);
      if (user) {
        account.logout({
          globalUserId: ck.cookie("globalUserId"),
          schemaId: this.tempSett.schemaId,
          sess: user.session
        });
      }
      ck.removeCookie(`smarketMember_${this.tempSett.schemaId}`, {
        path: "/",
        domain: window.$sk.config.domain
      });
    },
    login() {
      if (this.tempSett.registrationFormId == 0) {
        this.$message.error("尚未配置注册表单");
      } else {
        window.location.href = `${window.$sk.$help.replaceDomain(
          this.tempSett.loginPcUrl
        )}${this.backUrl}`;
      }
    },
    reg() {
      if (this.tempSett.registrationFormId == 0) {
        this.$message.error("尚未配置注册表单");
      } else {
        window.location.href = `${window.$sk.$help.replaceDomain(
          this.tempSett.registerPcUrl
        )}${this.backUrl}`;
      }
    }
  },
  created() {
    this.tempSett = this.$store.getters.getterTempConfig;
    this.initLogin();
  },
  computed: {
    tempConfig() {
      return this.$store.getters.getterTempConfig;
    }
  },
  watch: {
    tempConfig(val) {
      this.tempSett = val;
      this.initLogin();
    }
  }
};
</script>

<style scoped></style>
